// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__KLR4A","label":"LabeledBox_label__3FDlN"};